import { useEffect } from "react";
import { addScriptDefault } from "meta-pixel";

const FacebookPixel = () => {
  useEffect(() => {
    const pixelId = import.meta.env.VITE_FB_PIXEL_ID;
    if (!pixelId) return;

    // Add the fbq script and initialize
    const fbq = addScriptDefault();
    fbq("init", pixelId);
    fbq("track", "PageView");

    // Optional: cleanup function if you ever unmount
    return () => {
      // meta-pixel does not provide a remove method,
      // but you could remove the script manually if needed
      const script = document.querySelector(
        'script[src="https://connect.facebook.net/en_US/fbevents.js"]'
      );
      script?.parentNode?.removeChild(script);
    };
  }, []);

  // Optional noscript fallback
  const pixelId = import.meta.env.VITE_FB_PIXEL_ID;
  return pixelId ? (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        src={`https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`}
      />
    </noscript>
  ) : null;
};

export default FacebookPixel;
